import { encryptWithAes } from './aes-cipher';
import { arrayToBase64, base64ToArray } from './binary-utils';
import { AES_ENCRYPTION_ALGO_PARAMS } from './constants';
import { arrayToAesKey, cryptoKeyToArray, cryptoKeyToJwk, } from './crypto-binary-utils';
import { decryptWithRsaBlockCipher, encryptWithRsaBlockCipher, signRsa, verifyRsa, } from './rsa-cipher';
import { webCryptoTupleToArray } from './web-crypto-tuple';
export const stringToCryptoKey = (base64EncodedString, params) => arrayToAesKey(base64ToArray(base64EncodedString), params);
export const cryptoKeyToBase64 = (cryptoKey) => {
    return cryptoKeyToArray(cryptoKey).then((array) => arrayToBase64(array));
};
export const signPublicKey = async (publicKey, privateKey) => {
    const exportedPublicKey = await cryptoKeyToArray(publicKey);
    const signature = await signRsa(exportedPublicKey, privateKey);
    return arrayToBase64(signature);
};
export const signWebCryptoTuple = async (tuple, privateKey) => {
    const tupleArray = await webCryptoTupleToArray(tuple);
    const signature = await signRsa(tupleArray, privateKey);
    return arrayToBase64(signature);
};
export const verifyWebCryptoTuple = async (tuple, signedData, publicKey) => {
    const tupleArray = await webCryptoTupleToArray(tuple);
    return await verifyRsa(tupleArray, signedData, publicKey);
};
export const encryptCryptoKeyWithPublicKey = async (cryptoKey, publicKey) => {
    const exportedCryptoKey = await cryptoKeyToArray(cryptoKey);
    return encryptWithRsaBlockCipher(exportedCryptoKey, publicKey);
};
export const encryptCryptoKeyWithAes = async (privateKey, aesKey) => {
    const exportedPrivateKey = await cryptoKeyToArray(privateKey);
    return encryptWithAes(exportedPrivateKey, aesKey);
};
export const decryptAesKeyWithPrivateKey = async (base64Input, privateKey) => {
    const exportedCryptoKey = await decryptWithRsaBlockCipher(base64Input, privateKey);
    return arrayToAesKey(exportedCryptoKey, AES_ENCRYPTION_ALGO_PARAMS);
};
// This function assumes that one of the keys is valid
export const verifyPublicPrivateKeyPair = async (pair) => {
    const [jwkPublicKey, jwkPrivateKey] = await Promise.all([
        cryptoKeyToJwk(pair.publicKey),
        cryptoKeyToJwk(pair.privateKey),
    ]);
    if (jwkPrivateKey.kty === 'RSA') {
        return (jwkPublicKey.n === jwkPrivateKey.n &&
            jwkPublicKey.e === jwkPrivateKey.e &&
            jwkPublicKey.kty === jwkPrivateKey.kty);
    }
    else {
        throw new InvalidCryptoKeyError();
    }
};
export class InvalidCryptoKeyError extends Error {
    constructor() {
        super(`Invalid crypto key!`);
    }
}
